// titan-motion.js
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ease = 'cubic-bezier(0.22,1,0.36,1)';

  // ── Generic [data-tm] observer ──────────────────────────────────────────
  function observeDataTm() {
    var els = document.querySelectorAll('[data-tm]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tm-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  // ── Comparison table rows ───────────────────────────────────────────────
  function observeTableRows() {
    var rows = document.querySelectorAll('.comparison-table tbody tr');
    if (!rows.length) return;
    rows.forEach(function (r, i) {
      r.classList.add('tm-row-anim');
      r.style.transitionDelay = (i * 0.07) + 's';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tm-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    rows.forEach(function (r) { obs.observe(r); });
  }

  // ── Review cards ────────────────────────────────────────────────────────
  function observeReviews() {
    var cards = document.querySelectorAll('.rw-main-wrapper .rw-card, .rw-main-wrapper article, .lumin-review__item, [class*="review-card"]');
    if (!cards.length) {
      // fallback: direct children of review section
      var section = document.querySelector('#rw-top, .rw-main-wrapper');
      if (section) {
        var children = section.querySelectorAll('.rw-sub-wrapper > *');
        cards = children;
      }
    }
    if (!cards.length) return;
    cards.forEach(function (c, i) {
      c.classList.add('tm-review-anim');
      c.style.transitionDelay = (i * 0.1) + 's';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tm-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    cards.forEach(function (c) { obs.observe(c); });
  }

  // ── Lumin cards ─────────────────────────────────────────────────────────
  function observeLuminCards() {
    var wrappers = document.querySelectorAll('.lumin-card-wrapper, [class*="lumin-cards"] .card-wrapper, [class*="lumin-cards"] article');
    if (!wrappers.length) {
      // broader fallback
      wrappers = document.querySelectorAll('.lumin-cards .card, .lumin-cards li, .lumin-cards > div > div');
    }
    if (!wrappers.length) return;
    wrappers.forEach(function (c, i) {
      c.classList.add('tm-lcard-anim');
      c.style.transitionDelay = (i * 0.1) + 's';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tm-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    wrappers.forEach(function (c) { obs.observe(c); });
  }

  // ── 3 Images fan ────────────────────────────────────────────────────────
  function observe3Images() {
    // The ai_gen_block_43154a4 renders images in a flex row
    var containers = document.querySelectorAll('[class*="ai-three-images"], [class*="three-images"]');
    containers.forEach(function (container) {
      var imgs = container.querySelectorAll('img, .image-wrapper, figure');
      if (imgs.length < 2) return;
      imgs.forEach(function (img) { img.classList.add('tm-img-fan'); });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.querySelectorAll('.tm-img-fan').forEach(function (i) { i.classList.add('tm-visible'); });
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.2 });
      obs.observe(container);
    });
  }

  // ── Hero elements ────────────────────────────────────────────────────────
  function observeHeroElements() {
    // titan_hero_combined elements already have data-tm set in liquid
    // This is a fallback for any remaining hero elements
  }

  // ── Shimmer on CTA buttons ───────────────────────────────────────────────
  function shimmerButtons() {
    var btns = document.querySelectorAll('[class*="titan-hero-btn"], [class*="ai_gen"] a.button--primary');
    btns.forEach(function (btn) {
      var bg = window.getComputedStyle(btn).backgroundColor;
      // only add shimmer to gold buttons
      if (bg && (bg.includes('217') || bg.includes('212'))) {
        btn.style.backgroundImage = 'linear-gradient(90deg, #d9ac44 0%, #fedf8a 40%, #d9ac44 60%, #b8881e 100%)';
        btn.classList.add('tm-shimmer');
      }
    });
  }

  // ── Run all ──────────────────────────────────────────────────────────────
  function init() {
    observeDataTm();
    observeTableRows();
    observeReviews();
    observeLuminCards();
    observe3Images();
    shimmerButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor swaps section HTML via AJAX (no DOMContentLoaded),
  // which left newly-rendered blocks stuck at opacity:0 forever. Re-run on
  // every section/block render so edits made in the editor stay visible.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:block:select', init);
})();
